import DateFnsUtils from '@date-io/date-fns';
import {
  alpha,
  IconButton,
  InputAdornment,
  makeStyles,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const useStyles = makeStyles(({ palette }) => ({
  closeButton: {
    padding: 4,
    '&:hover': {
      backgroundColor: alpha(palette.action.disabled, 0.1),
    },
  },
  adornedEnd: {
    paddingRight: 4,
    '& .MuiIconButton-root': {
      padding: 4,
    },
    '& .MuiIconButton-label > svg': {
      width: 20,
      height: 20,
    },
  },
}));

interface DateFilterFieldProps {
  value: MaterialUiPickersDate | null;
  onFilter: (date: MaterialUiPickersDate | null) => void;
  onReset: () => void;
}

export default function DateFilterField({
  value,
  onFilter,
  onReset,
}: DateFilterFieldProps) {
  const classes = useStyles();

  const handleClearClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onReset();
  };

  const handleDateChange = (date: MaterialUiPickersDate | null) => {
    if (!date) {
      onReset();
      return;
    }
    if (!isValid(date)) return;
    onFilter(date);
  };

  return (
    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
      <KeyboardDatePicker
        size="small"
        disableToolbar
        variant="dialog"
        cancelLabel="Cancelar"
        inputVariant="outlined"
        showTodayButton={false}
        invalidDateMessage="Data inválida"
        format="dd/MM/yyyy"
        margin="none"
        id="date-picker-date-filter"
        label="Data"
        value={value || null}
        onChange={handleDateChange}
        InputAdornmentProps={{ position: 'end' }}
        InputProps={{
          classes: { adornedEnd: classes.adornedEnd },
          endAdornment: (
            <InputAdornment position="end" style={{ gap: 0 }}>
              {value && (
                <IconButton
                  size="small"
                  onClick={handleClearClick}
                  onMouseDown={e => e.preventDefault()}
                  title="Limpar filtro de data"
                  className={classes.closeButton}
                >
                  <Close style={{ width: 20, height: 20 }} />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        KeyboardButtonProps={{ 'aria-label': 'change date' }}
      />
    </MuiPickersUtilsProvider>
  );
}
